import type { FC, ReactNode } from 'react';
import ModalHeader from '../components/ModalHeader';
import ModalButtonBar from '../components/ModalButtonBar';
import { FioInput, PhoneInput } from '../components/UserDataInputs';
import type { ModalState } from '../types';

interface UserDataStageProps {
  modalStage: Extract<ModalState, 'userDataNew' | 'userDataEdit'>;
  fio: string;
  setFio: (v: string) => void;
  phone: string;
  setPhone: (v: string) => void;
  userComponent: (fioBlock: ReactNode, phoneBlock: ReactNode) => ReactNode;
  onBack: () => void;
  onSave: () => void;
}

const UserDataStage: FC<UserDataStageProps> = ({
  modalStage,
  fio,
  setFio,
  phone,
  setPhone,
  userComponent,
  onBack,
  onSave
}) => {
  const fioBlock = <FioInput value={fio} onChange={setFio} />;
  const phoneBlock = <PhoneInput value={phone} onChange={setPhone} />;

  return (
    <div className='left'>
      <div>
        <ModalHeader
          title={
            modalStage === 'userDataEdit'
              ? 'Изменить адрес'
              : 'Новый адрес доставки'
          }
          right={
            <>
              <span className='blacked'>2</span>
              /2
            </>
          }
          rightClassName='page'
        />
        <div className='address'>Получатель</div>
        {userComponent(fioBlock, phoneBlock)}
      </div>
      <ModalButtonBar
        variant='add-new-address'
        cancelLabel='Назад'
        onCancel={onBack}
        confirmLabel='Сохранить'
        onConfirm={onSave}
      />
    </div>
  );
};

export default UserDataStage;
